<div class="row">

  <mat-form-field class="col-3 official-jersey-number">
    <mat-label [matTooltip]="disabled ? disabledTooltip : jerseyNumberTooltip" matTooltipShowDelay="1000">##</mat-label>
    <input
      [formControl]="officialJerseyNumberControl"
      matInput
      type="number"
      [disabled]="disabled"
      [matTooltip]="disabled ? disabledTooltip : jerseyNumberTooltip"
      matTooltipShowDelay="1000"
    >
  </mat-form-field>

  <mat-form-field class="col-9">
    <mat-label>{{ officialLabel }}</mat-label>

    <input
      type="text"
      matInput
      [disabled]="disabled"
      [matTooltip]="disabled ? disabledTooltip : officialNameTooltip"
      matTooltipShowDelay="1000"
      [matTooltipPosition]="'below'"
      [attr.aria-label]="officialLabel"
      [placeholder]="'Type to search entire official\'s database'"
      [formControl]="officialFormControl"
      [matAutocomplete]="officialAutoComplete"
      required="false"
      (blur)="clearIfNotSet()"
    />

    <button
      *ngIf="officialFormControl.value && !disabled"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="$event.stopPropagation(); clear()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <mat-hint *ngIf="isGameOfficialUnknown()" align="start" class="danger-text"
      >{{ gameOfficialIsUnknown() }}
    </mat-hint>

    <mat-autocomplete
      #officialAutoComplete="matAutocomplete"
      (optionSelected)="selectionChange($event.option.value)"
      [displayWith]="officialFullName"
    >
      <mat-option *ngFor="let o of filteredOfficials$ | async" [value]="o">
        {{ officialFullName(o) }}
        <ng-container *ngIf="o.officialType || o.sihfId">
          (
          <span *ngIf="o.sihfId">SIHF-ID: {{ o.sihfId }}</span>
          <span *ngIf="o.officialType" class="official-type">
            , {{ o.officialType }}
          </span>
          )
        </ng-container>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
